const c = {
  name: "Hands11000",
  dimensions: { width: 35, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 38" style="enable-background:new 0 0 35 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,25v-9c0-2.2-1.8-4-4-4c-0.8,0-1.6,0.2-2.2,0.7c-0.5-1.6-2-2.7-3.8-2.7c-0.8,0-1.6,0.2-2.2,0.7
			C22.2,9.1,20.7,8,19,8c-0.7,0-1.4,0.2-2,0.5V4c0-2.2-1.8-4-4-4S9,1.8,9,4v15.5l-2-2.1c-1.4-1.7-3.9-1.9-5.6-0.5
			c-1.7,1.4-1.9,3.9-0.5,5.6l1.9,2.3l6.7,7.5C12.7,36,17.3,38,22,38C29.2,38,35,32.2,35,25z M13,2c1.1,0,2,0.9,2,2v15h-2v2h2
			c0,2.2,1.8,4,4,4c1.2,0,2.3-0.5,3-1.4c0.7,0.8,1.8,1.4,3,1.4c1.7,0,3.2-1.1,3.8-2.7c0.6,0.4,1.4,0.7,2.2,0.7c0.7,0,1.4-0.2,2-0.5
			V25c0,6.1-4.9,11-11,11c-4.2,0-8.1-1.8-10.9-4.9l-6.7-7.5l-1.9-2.3c-0.7-0.8-0.6-2.1,0.2-2.8c0.8-0.7,2.1-0.6,2.8,0.2l0,0l5.4,5.7
			V4C11,2.9,11.9,2,13,2z M31,21c-1.1,0-2-0.9-2-2v-3c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v3C33,20.1,32.1,21,31,21z M19,10
			c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2v-9C17,10.9,17.9,10,19,10z M23,14c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v7
			c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2V14z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands11000
};
